import ActionTypes from '../Actions/ActionTypes';

let initialState = {
  Analytics: {},
  Reviews: []
};

const ReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ANALYTICS:
      state = { ...state, Analytics: action.payload };
      break;  
      
      case ActionTypes.GET_REVIEWS:
      state = { ...state, Reviews: action.payload };
      break;

    default:
      break;
  }
  return state;
};

export default ReviewReducer;
